import { useEffect } from "react";
import Lenis from "lenis";

export default function useLenis() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.2,
        });

        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);

        // Anchor smooth scroll for internal links
        const onAnchor = (e) => {
            const a = e.target.closest("a[href^='#']");
            if (!a) return;
            const id = a.getAttribute("href").slice(1);
            const el = document.getElementById(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -60 });
            }
        };
        document.addEventListener("click", onAnchor);

        return () => {
            document.removeEventListener("click", onAnchor);
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);
}
